import angular from 'angular';

(function () {
    'use strict';

    angular.module('app.invitedentity').service('invitedEntitySvc', invitedEntitySvc);

    invitedEntitySvc.$inject = ['$sessionStorage', 'SellersDA', 'invitedEntityDA'];

    /* @ngInject */
    function invitedEntitySvc($sessionStorage, SellersDA, invitedEntityDA) {
        var exports = {
            searchFiltredInvitedEntity: searchFiltredInvitedEntity,
            getinvitedEntityListFilter: getinvitedEntityListFilter,
            searchInvitedEntitys: searchInvitedEntitys,
            getInvitedEntitySeller: getInvitedEntitySeller,
            getInvitedEntityBuyer: getInvitedEntityBuyer,
            initSessionStorage: initSessionStorage,
            searchInvBuyerRelations: searchInvBuyerRelations,
            canActivateInvitedEntity: canActivateInvitedEntity,
            activateInvitedEntity: activateInvitedEntity,
            deleteInvitedEntity: deleteInvitedEntity,
            resendInvitation: resendInvitation,
            reInviteRejectedSubEntities: reInviteRejectedSubEntities,
            updateSellerRobotKey: updateSellerRobotKey,
        };

        return exports;

        /**
         * Recherche des comptes invités
         */
        function searchInvitedEntitys(value) {
            $sessionStorage.invitedEntityListFilter = value;
            return invitedEntityDA.searchInvitedEntitys(value);
        }

        function searchFiltredInvitedEntity(InvitEntityFilter) {
            $sessionStorage.invitedEntityListFilter = InvitEntityFilter;
            // Supprime les 'ALL' pour le status (clone le filtre pour ne pas l'impacter)
            var filter = InvitEntityFilter.preparBeforeSearch();
            if(InvitEntityFilter.invited){
                filter.invited = true;
            }
            // return SellersDA.searchFiltredSellers(filter);
            return invitedEntityDA.searchFiltredInvitedEntity(filter);
        }

        function searchInvBuyerRelations(id, invBuyerRelationFilter) {
            var filter = invBuyerRelationFilter.preparBeforeSearch();
            return invitedEntityDA.searchInvBuyerRelations(id, filter);
        }

        function getinvitedEntityListFilter() {
            return $sessionStorage.invitedEntityListFilter;
        }

        /**
         * Recupere un compte invité de type Seller
         */
        function getInvitedEntitySeller(sellerId) {
            // $sessionStorage.invitedEntityListFilter = value;
            return invitedEntityDA.getInvitedEntitySeller(sellerId);
        }

        /**
         * Recupere un compte invité de type buyer
         */
        function getInvitedEntityBuyer(buyerId) {
            // $sessionStorage.invitedEntityListFilter = value;
            return invitedEntityDA.getInvitedEntityBuyer(buyerId);
        }

        function initSessionStorage() {
            $sessionStorage.invitedEntityListFilter = null;
            $sessionStorage.getInvitedBuyerLinkRequestFilter = null;
        }

        function canActivateInvitedEntity(invitedentityId) {
            return invitedEntityDA.canActivateInvitedEntity(invitedentityId);
        }

        function activateInvitedEntity(invitedentityId) {
            return invitedEntityDA.activateInvitedEntity(invitedentityId);
        }

        /**
         * supprime un compte invité de type buyer ou seller
         */
        function deleteInvitedEntity(invitedentityId) {
            return invitedEntityDA.deleteInvitedEntity(invitedentityId);
        }

        function resendInvitation(invitationId, invitationEmail) {
            return invitedEntityDA.resendInvitation(invitationId, invitationEmail);
        }

        /**
         * Réinviter des établissements rejetés
         */
        function reInviteRejectedSubEntities(subEntities, invitedEntityId) {
            return invitedEntityDA.reInviteRejectedSubEntities(subEntities, invitedEntityId);
        }

        /**
         * Permet de modifier le code émetteur du fournisseur invité
         */
        function updateSellerRobotKey(invitedEntityId, sellerRobotKey) {
            return invitedEntityDA.updateSellerRobotKey(invitedEntityId, sellerRobotKey);
        }
    }
})();
